import { ExtratoProvider } from './Components/Financeiro/ExtratoBancario/context/extrato-bancario-context';
import { MovimentacaoProvider } from './Components/Financeiro/MovimentacaoBancaria/context/movimentacao-bancario-context';
import Routes from './Routes/routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import { StoreProvider } from './context/store-context';
import { AuthProvider } from './context/Auth';
import { ReduxProvider } from './redux/features/provider';
import { ToastContainer } from 'react-toastify';
import { ReactQueryProvider } from './apiQuery/ReactQueryProvider';

export function App() {
  return (
    <ReactQueryProvider>
      <AuthProvider>
        <StoreProvider>
          <ExtratoProvider>
            <MovimentacaoProvider>
              <ReduxProvider>
                <Routes />
                <ToastContainer position="top-right" autoClose={2000} />
              </ReduxProvider>
            </MovimentacaoProvider>
          </ExtratoProvider>
        </StoreProvider>
      </AuthProvider>
    </ReactQueryProvider>
  );
}
